// extracted by mini-css-extract-plugin
module.exports = {"tableHeadRow":"PackagingStockCard_tableHeadRow__3u0vR","headlineCard":"PackagingStockCard_headlineCard__31Ole","tableHead":"PackagingStockCard_tableHead__2rQtr"};